import React,{useState} from 'react';
import './App.css';

import Alert from './components/Alert';
import NAVBAR from './components/NAVBAR';
import Textforms from './components/Textforms'





function App() {
  const [alert, setalert] = useState(null);
   const showAlert=(message,type)=>{
    setalert({
      msg:message,
      type:type
    })
    setTimeout(() => {
      setalert(null)
    }, 1500);
   }
  const [mode, setMode] = useState('light')//whether dark mode is enable or not
  const toggleMode=()=>{
    if(mode==='light'){
      setMode('dark')
      document.body.style.backgroundColor='#042743';
      showAlert("Dark mode has been enabled","success");
      document.title='TextUtils-Dark Mode'
    }
    else{
      setMode('light')
      document.body.style.backgroundColor='white';
      showAlert("Light mode has been enabled","success");
      document.title='TextUtils-Light Mode'
    }
  }
   




  return (
   <>
     {/* <Router> */}
   <NAVBAR title="TextUtils" aboutText="About" mode={mode} toggleMode={toggleMode}/>
  <Alert alert={alert} />
  
  
   <div className="container mb-3">
  

   
          
   {/* <Switch>
          <Route exact path="/about">
            <About mode={mode} /> */}
          {/* </Route> */}
         
          {/* <Route exact path="/"> */}
      <Textforms showAlert={showAlert} heading="Try TextUtils-Word counter,character Counter,Remove Extra spaces " mode={mode}/>
            
          {/* </Route> */}
        {/* </Switch> */}
         
          
           
        

  
  
   </div>
    {/* </Router> */}
   </>
  );
}

export default App;
